import useFullscreenProps from './useFullscreenProps';
import useFunModeProps from './useFunModeProps';
import useGameOptionsProps from './useGameOptionsProps';
import useNewGameSessionProps from './useGameSessionProps/useNewGameSessionProps';
import useInGameCurrencyProps from './useInGameCurrencyProps';

type Props = {
  game: SingleGameFragment;
  gameDescription?: GameDescriptionFragment;
  gameSession?: GameSessionFragment;
};

const useNewGameContextProvider = ({
  game,
  gameDescription,
  gameSession,
}: Props) => {
  const { isFunMode, setFunMode } = useFunModeProps(game);
  const { options, setOptions } = useGameOptionsProps();
  const inGameCurrencyProps = useInGameCurrencyProps(game);
  const gameSessionProps = useNewGameSessionProps({
    isFunMode,
    game,
    gameSession,
    inGameCurrency: inGameCurrencyProps.inGameCurrency ?? undefined,
  });
  const fullscreenProps = useFullscreenProps();
  const value = {
    game,
    description: gameDescription,
    isFunMode,
    setFunMode,
    options,
    setOptions,
    ...inGameCurrencyProps,
    ...gameSessionProps,
    ...fullscreenProps,
  };
  return { value };
};
export default useNewGameContextProvider;
